module.exports = __webpack_public_path__ + "static/img/咨询二维码.e136b51.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/咨询二维码.png
// module id = Nsr4
// module chunks = 74